import { useSyncExternalStore } from "react";
import { sessionSnapshot, subscribeToSession } from "./session";

/**
 * Is there a session, right now?
 *
 * `useSyncExternalStore` because that is exactly what this is: state living
 * outside React — in the browser's storage, shared with every other tab — that
 * the interface must follow. Rolling it by hand with an effect would tear on the
 * first concurrent render.
 */
export function useSession(): boolean {
  return useSyncExternalStore(
    subscribeToSession,
    sessionSnapshot,
    // Server snapshot: no storage, no session. Never reached today (no SSR), but
    // the signature demands an answer and "signed in" would be the wrong one.
    () => false,
  );
}
